import {InvitationsTable} from "./InvitationsTable";


export  class MembersTable extends InvitationsTable {
    static name = "members-table";

    get name() {
        return MembersTable.name;
    }


}
